/// <reference types="./PublishedSchema.d.ts" />
import { BaseSchema } from './BaseSchema.js';
import {} from './SchemaSpecification.js';
export class PublishedSchema extends BaseSchema {
    constructor(spec) {
        super(spec);
    }
}
//# sourceMappingURL=PublishedSchema.js.map